import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-57dd90f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lf" }
const _hoisted_2 = { class: "lf__elm" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lf__elm-label" }, "Введите номер телефона", -1))
const _hoisted_4 = {
  key: 0,
  class: "lf__elm-channel"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lf__elm-channel-item-label" }, "WhatsApp", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lf__elm-channel-item-label" }, "Telegram", -1))
const _hoisted_7 = { class: "lf__elm-phone" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconWhatsApp = _resolveComponent("IconWhatsApp")!
  const _component_IconTelegram = _resolveComponent("IconTelegram")!
  const _component_MazPhoneNumberInput = _resolveComponent("MazPhoneNumberInput")!
  const _component_UiButton = _resolveComponent("UiButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      false
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.redirect('tapi'))),
              class: _normalizeClass(
						_ctx.serviceName === 'wapi'
							? 'lf__elm-channel-item_current'
							: 'lf__elm-channel-item'
					)
            }, [
              _createVNode(_component_IconWhatsApp),
              _hoisted_5
            ], 2),
            _createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.redirect('wapi'))),
              class: _normalizeClass(
						_ctx.serviceName === 'tapi'
							? 'lf__elm-channel-item_current'
							: 'lf__elm-channel-item'
					)
            }, [
              _createVNode(_component_IconTelegram),
              _hoisted_6
            ], 2)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_MazPhoneNumberInput, {
          modelValue: _ctx.number,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.number) = $event)),
          onUpdate: _ctx.numberHandler,
          onKeyup: _withKeys(_ctx.onClickGetCode, ["enter"]),
          translations: {
						countrySelector: {
							placeholder: 'Код страны',
						},
						phoneInput: {
							placeholder: 'Номер телефона',
							example: 'Пример:',
						},
					}
        }, null, 8, ["modelValue", "onUpdate", "onKeyup"]),
        _createVNode(_component_UiButton, {
          onClick: _ctx.onClickGetCode,
          class: "lf__elm-phone-btn",
          label: "Получить код",
          "background-color": 
						_ctx.isInputEmpty
							? 'rgb(244, 246, 250)'
							: 'var(--theme-color)'
					,
          "border-color": 
						_ctx.isInputEmpty
							? 'rgb(244, 246, 250)'
							: 'var(--theme-color)'
					,
          color: 
						_ctx.isInputEmpty
							? 'rgb(188, 192, 207)'
							: 'rgb(255, 255, 255)'
					,
          "font-weight": "600",
          "font-size": "16px"
        }, null, 8, ["onClick", "background-color", "border-color", "color"])
      ])
    ])
  ]))
}